import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import HomePage from "@/views/HomePage.vue"
import BlogPage from "@/views/BlogPage.vue"
import BlogPost from "@/views/BlogPost.vue"
import AboutPage from "@/views/AboutPage.vue"
import PerfectTyping from "@/views/PerfectTyping.vue"
import ProjectPage from "@/views/projects/ProjectPage.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
    meta: {
      title: "Home Page - Gordon Cheng",
      description: "Home page of Gordon Cheng."
    }
  },
  {
    path: "/blog",
    name: "BlogPage",
    component: BlogPage,
    meta: {
      title: "Blog Page - Gordon Cheng",
      description: "Blog page of Gordon Cheng."
    }
  },
  {
    path: "/blog/:year/:slug",
    name: "BlogPost",
    component: BlogPost,
    props: true,
    meta: {
      title: "Blog Post - Gordon Cheng",
      description: "Blog post of Gordon Cheng."
    }
  },
  {
    path: "/about",
    name: "AboutPage",
    component: AboutPage,
    meta: {
      title: "About page - Gordon Cheng",
      description: "About page of Gordon Cheng."
    }
  },
  {
    path: "/projects",
    name: "Projects",
    component: ProjectPage,
    meta: {
      title: "Projects page - Gordon Cheng",
      description: "Projects page of Gordon Cheng."
    }
  },
  {
    path: "/projects/:slug",
    name: "ProjectPage",
    component: ProjectPage,
    props: true
  },
  {
    path: "/projects/perfect-typing",
    name: "PerfectTypingBase",
    component: PerfectTyping
  },
  {
    path: "/projects/perfect-typing/:title",
    name: "PerfectTypingWithTitle",
    component: PerfectTyping,
    props: true,
    meta: {
      title: "Project Page - Perfect Typing - Gordon Cheng",
      description: "Perfect Typing Game"
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title as string
  }

  const metaDescription = document.querySelector('meta[name="description"]')
  if (to.meta.description) {
    if (metaDescription) {
      metaDescription.setAttribute("content", to.meta.description as string)
    } else {
      const newMetaDescription = document.createElement("meta")
      newMetaDescription.setAttribute("name", "description")
      newMetaDescription.setAttribute("content", to.meta.description as string)
      document.head.appendChild(newMetaDescription)
    }
  }
})

export default router
